<p-drawer [visible]="visible()" (onHide)="onDrawerHide()" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-config-sidebar w-72" header="Settings">
  <div class="flex flex-col gap-6">
    <div class="flex items-center gap-2">
      <span class="text-xs font-bold uppercase tracking-widest text-muted-color">PrimeNG</span>
      <span class="flex-1 h-px bg-surface-200 dark:bg-surface-700"></span>
    </div>
    <div>
      <span class="text-lg font-semibold">Primary</span>
      <div class="pt-2 flex gap-2 flex-wrap">
        @for (primaryColor of primaryColors(); track primaryColor.name) {
          <button
            type="button"
            [title]="primaryColor.name"
            (click)="updateColors($event, 'primary', primaryColor)"
                                [ngClass]="{
                                    'outline-primary': primaryColor.name === selectedPrimaryColor()
                                }"
            class="cursor-pointer w-6 h-6 rounded-full flex shrink-0 items-center justify-center p-0 outline-0 outline-offset-1"
                                [style]="{
                                    'background-color': primaryColor?.name === 'noir' ? 'var(--text-color)' : primaryColor?.palette?.['500']
                                }"
          ></button>
        }
      </div>
    </div>

    <div>
      <span class="text-lg font-semibold">Surface</span>
      <div class="pt-2 flex gap-2 flex-wrap">
        @for (surface of surfaces; track surface.name) {
          <button
            type="button"
            [title]="surface.name"
            (click)="updateColors($event, 'surface', surface)"
            class="cursor-pointer w-6 h-6 rounded-full flex shrink-0 items-center justify-center p-0 outline-0 outline-offset-1"
                                [ngClass]="{
                                    'outline-primary': selectedSurface() ? selectedSurface() === surface.name : darkTheme() ? surface.name === 'zinc' : surface.name === 'slate'
                                }"
                                [style]="{
                                    'background-color': surface?.palette?.['500']
                                }"
          ></button>
        }
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-lg font-semibold">Presets</span>
      <p-selectbutton [options]="presets" [ngModel]="selectedPreset()" (ngModelChange)="onPresetChange($event)" [allowEmpty]="false"></p-selectbutton>
    </div>

    <div class="flex flex-col gap-2">
      <span class="text-lg font-semibold">Color Scheme</span>
      <p-selectbutton [ngModel]="darkTheme()" (ngModelChange)="toggleDarkMode()" [options]="themeOptions" optionLabel="name" optionValue="value" [allowEmpty]="false"></p-selectbutton>
    </div>

    @if (!simple) {
      <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold">Menu Type</span>
        <div class="flex flex-wrap flex-col gap-4">
          <div class="flex">
            <!-- <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="static" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('static')" inputId="static"></p-radio-button>
              <label for="static">Static</label>
            </div> -->
            <!-- <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="overlay" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('overlay')" inputId="overlay"></p-radio-button>
              <label for="overlay">Overlay</label>
            </div> -->
          </div>
          <div class="flex">
            <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="slim" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('slim')" inputId="slim"></p-radio-button>
              <label for="slim">Slim</label>
            </div>
            <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="slim-plus" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('slim-plus')" inputId="slim-plus"></p-radio-button>
              <label for="slim-plus">Slim+</label>
            </div>
          </div>
          <div class="flex">
            <!-- <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="reveal" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('reveal')" inputId="reveal"></p-radio-button>
              <label for="reveal">Reveal</label>
            </div> -->
            <!-- <div class="flex items-center gap-2 w-1/2">
              <p-radio-button name="menuMode" value="drawer" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('drawer')" inputId="drawer"></p-radio-button>
              <label for="drawer">Drawer</label>
            </div> -->
          </div>
          <!-- <div class="flex items-center gap-2 w-1/2">
            <p-radio-button name="menuMode" value="horizontal" [(ngModel)]="menuMode" (ngModelChange)="setMenuMode('horizontal')" inputId="horizontal"></p-radio-button>
            <label for="horizontal">Horizontal</label>
          </div> -->
        </div>
      </div>
    }

    @if (!simple) {
      <!-- <div class="flex flex-col gap-2">
        <span class="text-lg font-semibold">Menu Theme</span>
        <div class="flex flex-wrap flex-col gap-6">
          <div class="flex items-center gap-2">
            <p-radiobutton name="menuTheme" value="colorScheme" [ngModel]="menuTheme()" (ngModelChange)="setMenuTheme('colorScheme')" inputId="menutheme-colorscheme"></p-radiobutton>
            <label for="scheme">Color Scheme</label>
          </div>
          <div class="flex items-center gap-2">
            <p-radiobutton name="menuTheme" value="primaryColor" [ngModel]="menuTheme()" (ngModelChange)="setMenuTheme('primaryColor')" inputId="menutheme-primarycolor"></p-radiobutton>
            <label for="primary">Primary Color</label>
          </div>
          <div class="flex items-center gap-2">
            <p-radiobutton name="menuTheme" value="transparent" [ngModel]="menuTheme()" (ngModelChange)="setMenuTheme('transparent')" inputId="menutheme-transparent" [disabled]="isTransparentThemeOptionDisabled()"></p-radiobutton>
            <label for="transparent">Transparent</label>
          </div>
        </div>
      </div> -->
    }

    @if (authService.isCodyAdministratorComputedSignal()) {
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2">
          <span class="text-xs font-bold uppercase tracking-widest text-muted-color">daisyUI</span>
          <span class="flex-1 h-px bg-surface-200 dark:bg-surface-700"></span>
        </div>
        <span class="text-lg font-semibold">Themes</span>
        <span class="text-xs text-muted-color">daisyUI components only. Saved to your account.</span>
        <!--
          Plain buttons styled like the theme cards below, to match this PrimeNG drawer. A card only previews; Save
          keeps it, and closing without saving goes back to what is saved. Revert selects the default, which Save
          then commits.

          `aria-disabled` rather than `disabled`: disabling the button under the click that used it would drop
          keyboard focus out of the drawer. The service ignores a save with nothing to save.
        -->
        <div class="flex items-center justify-between gap-2">
          <button type="button"
            class="flex items-center gap-1.5 rounded-lg border border-surface-200 dark:border-surface-700 px-3 py-1.5 text-sm"
            [ngClass]="isDefaultTheme() ? 'cursor-default opacity-50' : 'cursor-pointer'"
            [attr.aria-disabled]="isDefaultTheme()" (click)="resetDaisyTheme()">
            <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
            Revert to Pathfinder default
          </button>
          <button type="button"
            class="flex items-center gap-1.5 rounded-lg border border-primary bg-primary px-3 py-1.5 text-sm font-medium text-primary-contrast"
            [ngClass]="hasUnsavedTheme() ? 'cursor-pointer' : 'cursor-default opacity-50'"
            [attr.aria-disabled]="!hasUnsavedTheme()" (click)="saveDaisyTheme()">
            <i class="fa-regular fa-floppy-disk" aria-hidden="true"></i>
            Save
          </button>
        </div>
        <div class="mt-1 flex flex-col gap-2 max-h-72 overflow-y-auto pr-1">
          @for (group of themeGroups; track group.label) {
            <span class="mt-1 text-xs font-semibold uppercase tracking-widest text-muted-color">{{ group.label }}</span>
            @for (theme of group.themes; track theme.value) {
              <button
                type="button"
                [attr.data-theme]="theme.value"
                [attr.aria-pressed]="theme.value === selectedDaisyTheme()"
                [attr.aria-label]="theme.label + ' theme'"
                (click)="setDaisyTheme(theme.value)"
                [ngClass]="{ 'outline outline-2 outline-offset-1 outline-primary': theme.value === selectedDaisyTheme() }"
                class="flex items-center justify-between rounded-lg border border-surface-200 dark:border-surface-700 p-2 cursor-pointer"
                [style.background-color]="'var(--color-base-100)'"
                [style.color]="'var(--color-base-content)'"
              >
                <span class="capitalize text-sm font-medium">{{ theme.label }}</span>
                <span class="flex gap-1">
                  <span class="w-2 h-4 rounded" [style.background-color]="'var(--color-primary)'"></span>
                  <span class="w-2 h-4 rounded" [style.background-color]="'var(--color-secondary)'"></span>
                  <span class="w-2 h-4 rounded" [style.background-color]="'var(--color-accent)'"></span>
                  <span class="w-2 h-4 rounded" [style.background-color]="'var(--color-neutral)'"></span>
                </span>
              </button>
            }
          }
        </div>
      </div>
    }
  </div>
</p-drawer>
